
// Module
import routes from './routes';

export default angular.module( 'app.resetPassword.module',
    [] )
    .config(routes)
    .name;



/** WEBPACK FOOTER **
 ** ./src/guest/resetPassword/index.js
 **/